import { Icon, mergeStyleSets, Panel, PanelType } from "office-ui-fabric-react";
import React, { useState } from "react";
import { connect } from "react-redux";
import { State } from "../../store";
import * as GeneralStore from "../../store/GeneralStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import FileUpload from "../common/FIleUpload";

type Props = GeneralStore.GeneralState &
    LineHandlingStore.LineHandlingState;

const classes = mergeStyleSets({
    viewButtonUpload: {
        width: "39px",
        height: "39px",
        borderRadius: "5px",
        border: "1px solid #E2E6E8",
        backgroundColor: "#FAFAFA",
        display: "block",
        padding: "0",
        cursor: "pointer",
        selectors: {
            ":hover": {
                backgroundColor: "#EEEEEE",
                textDecoration: "none"
            }
        }
    },
    viewIconUpload: {
        color: "#4C4C4C",
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        textAlign: "center"
    },
});

const AttachmentModal: React.FC<Props> = (props: Props) => {
    const [isOpenAttachment, setIsOpenAttachment] = useState(false);
    const { lineHandling } = props;
    console.log({ props })
    return (
        <>
            {
                (!lineHandling?.isLoading && lineHandling?.result) &&
                <div className={classes.viewButtonUpload}>
                    <Icon
                        iconName="Attach"
                        className={classes.viewIconUpload}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setIsOpenAttachment(true);
                        }}
                    />
                </div>
            }
            {
                isOpenAttachment &&
                <Panel
                    isLightDismiss
                    isOpen={isOpenAttachment}
                    onDismiss={() => setIsOpenAttachment(false)}
                    closeButtonAriaLabel="Close"
                    type={PanelType.smallFluid}
                    className="upload-panel"
                    layerProps={{ eventBubblingEnabled: true }}
                    styles={{
                        scrollableContent: { overflow: "visible" },
                        content: { overflow: "visible" },
                    }}
                    >
                    <FileUpload
                        lineHandling={lineHandling.result!}
                        canUploadFile={props.isMarineUploadFileAllowed}
                    />
                </Panel>
            }
        </>
    );
}

export default connect(
    (state: State) => ({
        ...state.general,
        ...state.lineHandling,
    }),
    null
)(AttachmentModal as any);